export default "__VITE_ASSET__nY29lc7d__"